export interface ReviewItem {
  id: number;
  username: string;
  avatar: string;
  rating: number;
  content: string;
  date: string;
}

export const aboutInfo = {
  brandName: '樱花动漫',
  brandIntro:
    '樱花动漫成立于2018年，是国内领先的日本漫画在线阅读平台。我们致力于为广大动漫爱好者提供高质量、正版的日本漫画阅读体验。平台收录了超过5000部漫画作品，涵盖了少年、少女、青年、奇幻、恋爱等多个分类，满足不同读者的口味需求。',
  mission:
    '让每一位漫画爱好者都能轻松地找到自己喜欢的作品，享受阅读的乐趣。我们相信，好的漫画能够跨越国界，传递感动与力量。',
  history: [
    { year: '2018', event: '樱花动漫正式上线，初始收录1000部漫画' },
    { year: '2019', event: '用户突破100万，新增分类筛选功能' },
    { year: '2020', event: '推出移动端适配，支持手机阅读' },
    { year: '2021', event: '漫画收录量突破3000部，建立作者合作计划' },
    { year: '2022', event: '用户突破500万，推出社区评论功能' },
    { year: '2023', event: '获得年度最佳动漫阅读平台奖' },
    { year: '2024', event: '漫画收录量突破5000部，全面升级阅读体验' },
  ],
  stats: [
    { label: '收录漫画', value: '5,000+' },
    { label: '活跃用户', value: '500万+' },
    { label: '日访问量', value: '200万+' },
    { label: '合作作者', value: '300+' },
  ],
  reviews: [
    {
      id: 1,
      username: '二次元老司机',
      avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20of%20a%20boy%20with%20glasses%2C%20simple%20background&width=100&height=100&seq=avatar-review-01&orientation=squarish',
      rating: 5,
      content: '用了樱花动漫快三年了，资源是真的全！我追的冷门漫画在这里都能找到，而且更新速度很快，基本和日本同步。页面也很清爽，没有乱七八糟的广告，强烈推荐！',
      date: '2026-07-15',
    },
    {
      id: 2,
      username: '漫画控小樱',
      avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20avatar%20of%20a%20girl%20with%20pink%20hair%2C%20simple%20background&width=100&height=100&seq=avatar-review-02&orientation=squarish',
      rating: 5,
      content: '作为一个看了十几年漫画的老读者，樱花动漫的阅读体验真的没话说。分类很细致，找漫画特别方便。而且每部漫画都有详细的简介和标签，帮我发现了好多宝藏作品！',
      date: '2026-07-10',
    },
    {
      id: 3,
      username: '追番达人K',
      avatar: 'https://readdy.ai/api/search-image?query=Cool%20anime%20style%20avatar%20of%20a%20boy%20with%20headphones%2C%20simple%20background&width=100&height=100&seq=avatar-review-03&orientation=squarish',
      rating: 4,
      content: '整体体验很棒，漫画质量很高，翻译也很用心。希望能增加更多轻小说改编的作品。另外，如果能有离线下载功能就更好了，不过目前已经很满意了。',
      date: '2026-07-08',
    },
    {
      id: 4,
      username: '深夜看漫人',
      avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20avatar%20of%20a%20girl%20with%20dark%20hair%2C%20simple%20background&width=100&height=100&seq=avatar-review-04&orientation=squarish',
      rating: 5,
      content: '每天晚上必刷樱花动漫！界面很简洁，加载速度也快。最喜欢的是每一话底部的评论区，和同好们讨论剧情真的太快乐了。感谢平台提供了这么好的交流空间！',
      date: '2026-07-05',
    },
    {
      id: 5,
      username: '漫画收藏家',
      avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20avatar%20of%20a%20boy%20with%20blue%20hair%2C%20simple%20background&width=100&height=100&seq=avatar-review-05&orientation=squarish',
      rating: 5,
      content: '这款平台改变了我看漫画的方式。以前到处找资源，现在所有想看的都在樱花动漫上。收藏功能特别好用，可以追踪更新进度。满分好评！',
      date: '2026-06-28',
    },
  ] as ReviewItem[],
  contact: {
    email: 'contact@sakuracomic.cn',
    weibo: '@樱花动漫官方',
    wechat: 'sakuracomic2024',
    address: '上海市浦东新区张江高科技园区樱花路888号',
    phone: '400-888-6688',
  },
  faqs: [
    {
      question: '樱花动漫的所有漫画都是免费的吗？',
      answer: '是的，樱花动漫平台上的所有漫画目前均为免费阅读。我们通过广告和会员增值服务来维持平台运营，保证广大读者能够无门槛地享受漫画阅读的乐趣。',
    },
    {
      question: '漫画的更新频率是怎样的？',
      answer: '热门连载漫画通常与日本同步更新，一般每周更新一话。部分作品根据作者更新节奏可能为双周更或月更。您可以在每部漫画的详情页查看最新的更新时间。',
    },
    {
      question: '如何找到我想看的漫画？',
      answer: '您可以通过首页的搜索框输入漫画名称搜索，也可以通过分类页面按漫画类型筛选。此外，首页的"热门推荐"和"最新更新"板块也会帮您发现优质作品。',
    },
    {
      question: '支持手机端阅读吗？',
      answer: '当然支持！樱花动漫的网页版已全面适配移动端，您可以在手机浏览器上流畅地阅读所有漫画。同时我们也提供了适合手机屏幕的竖屏阅读模式，带来更舒适的移动阅读体验。',
    },
    {
      question: '如果漫画缺页或出现显示问题怎么办？',
      answer: '如遇到任何阅读问题，您可以通过"关于我们"页面的联系方式与我们取得联系，或直接在漫画评论区反馈。我们的技术团队会尽快处理并修复问题。',
    },
  ],
};